import { SHOW_OR_HIDE_GENERAL_DASHBOARD_LEFT_MENU } from "../../Constants/reduxKeys";

export function showOrHideGeneralDashboardLeftMenu(bool) {
  return {
    type: SHOW_OR_HIDE_GENERAL_DASHBOARD_LEFT_MENU,
    payload: bool,
  };
};